import React from 'react';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
const months = [{
  value: '1',
  label: 'January'
}, {
  value: '2',
  label: 'February'
}, {
  value: '3',
  label: 'March'
}, {
  value: '4',
  label: 'April'
}, {
  value: '5',
  label: 'May'
}, {
  value: '6',
  label: 'June'
}, {
  value: '7',
  label: 'July'
}, {
  value: '8',
  label: 'August'
}, {
  value: '9',
  label: 'September'
}, {
  value: '10',
  label: 'October'
}, {
  value: '11',
  label: 'November'
}, {
  value: '12',
  label: 'December'
}];
const days = Array.from({
  length: 31
}, (_, i) => ({
  value: String(i + 1),
  label: String(i + 1)
}));
const years = Array.from({
  length: 10
}, (_, i) => {
  const y = 2026 - i;
  return {
    value: String(y),
    label: String(y)
  };
});
const dateSelect = 'h-10 rounded-md border border-slate-300 bg-white px-2 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400';
export function ExportUsers() {
  return <div className="space-y-6" data-id="element-1067">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1068">Export Users</h1>

      <Card data-id="element-1069">
        <CardContent className="pt-6 space-y-5 max-w-sm" data-id="element-1070">
          <div data-id="element-1071">
            <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1072">
              Start Date
            </label>
            <div className="flex items-center gap-1" data-id="element-1073">
              <select defaultValue="2" className={dateSelect} data-id="element-1074">
                {months.map(m => <option key={m.value} value={m.value} data-id="element-1075">
                    {m.label}
                  </option>)}
              </select>
              <span className="text-slate-500" data-id="element-1076">/</span>
              <select defaultValue="11" className={`${dateSelect} w-16`} data-id="element-1077">
                {days.map(d => <option key={d.value} value={d.value} data-id="element-1078">
                    {d.label}
                  </option>)}
              </select>
              <span className="text-slate-500" data-id="element-1079">/</span>
              <select defaultValue="2026" className={`${dateSelect} w-20`} data-id="element-1080">
                {years.map(y => <option key={y.value} value={y.value} data-id="element-1081">
                    {y.label}
                  </option>)}
              </select>
            </div>
          </div>

          <div data-id="element-1082">
            <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1083">
              End Date
            </label>
            <div className="flex items-center gap-1" data-id="element-1084">
              <select defaultValue="2" className={dateSelect} data-id="element-1085">
                {months.map(m => <option key={m.value} value={m.value} data-id="element-1086">
                    {m.label}
                  </option>)}
              </select>
              <span className="text-slate-500" data-id="element-1087">/</span>
              <select defaultValue="11" className={`${dateSelect} w-16`} data-id="element-1088">
                {days.map(d => <option key={d.value} value={d.value} data-id="element-1089">
                    {d.label}
                  </option>)}
              </select>
              <span className="text-slate-500" data-id="element-1090">/</span>
              <select defaultValue="2026" className={`${dateSelect} w-20`} data-id="element-1091">
                {years.map(y => <option key={y.value} value={y.value} data-id="element-1092">
                    {y.label}
                  </option>)}
              </select>
            </div>
          </div>

          <div className="pt-2" data-id="element-1093">
            <Button data-id="element-1094">Export</Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}